<template>
  <div>
    <top>
      <p slot="center">
        <span
          :class="{ active: isList }"
          @click="clickTab('list')"
          style="margin-right: 20px"
          >列表</span
        >
        <span :class="{ active: !isList }" @click="clickTab('map')">地图</span>
      </p>
      <p slot="right" @click="openGroup">车组</p>
    </top>
    <div id="mylist">
      <div id="carListwrap" v-show="isList">
        <carTool ref="carTool" @car="reCar" @allCar="reAllCar"></carTool>
      </div>
      <div id="lymap" v-show="!isList">
        <div id="window">
          <p id="wintop" @click="showMsg = !showMsg">
            <Icon :type="showMsg ? 'ios-arrow-down' : 'ios-arrow-up'" />
          </p>
          <div id="windowBody" v-show="showMsg">
            <icon-window v-if="!isList" :windowData="activeCar">
              <b slot="carNo" @click="carBack">{{ activeCar.carNo }}</b>
              <p @click="carBack" slot="address" style="line-height: 18px">
                {{ address }}
              </p>
              <Dropdown slot="btn1">
                <Button long>常规操作</Button>
                <template #list>
                  <DropdownMenu>
                    <DropdownItem
                      ><Button long @click="huifang"
                        >历史轨迹</Button
                      ></DropdownItem
                    >
                    <DropdownItem
                      ><Button long @click="reVideo"
                        >查看视频</Button
                      ></DropdownItem
                    >
                    <DropdownItem>
                      <Button long @click="toSpeakPage"
                        >语音对讲</Button
                      ></DropdownItem
                    >
                    <DropdownItem>
                      <Button long @click="zhiling"
                        >指令下发</Button
                      ></DropdownItem
                    >
                  </DropdownMenu>
                </template>
              </Dropdown>
              <Button long slot="btn2" @click="jiejing">查看街景</Button>
            </icon-window>
          </div>
        </div>
        <show-set
          @lukuang="reLuKuang"
          @yun="reYun"
          @pointData="rePointData"
          @lineData="reLineData"
          @fenceData="reFenceData"
        ></show-set>
      </div>
    </div>
    <Drawer
      placement="top"
      :closable="true"
      :mask="true"
      :draggable="false"
      height="90%"
      v-model="openStree"
    >
      <stree ref="bmapStree" v-if="openStree"></stree>
    </Drawer>
    <Drawer
      placement="bottom"
      :closable="true"
      :mask="true"
      :draggable="false"
      height="300"
      v-model="openSelect"
    >
      <ly-select v-if="openSelect" @history="getHistory"></ly-select>
    </Drawer>
    <Drawer
      placement="right"
      :closable="true"
      :mask="true"
      :draggable="false"
      width="100%"
      v-model="openLocus"
      :title="'轨迹：' + $store.state.carMsg.carNo"
    >
      <locusmap
        v-if="openLocus"
        @closeMap="openMap = false"
        ref="locus"
      ></locusmap>
      <Button>轨迹纠偏</Button>
    </Drawer>
    <Modal
      v-model="openVideo"
      footer-hide
      class-name="vertical-center-modal"
      width="100%"
      @on-cancel="closeVideo"
    >
      <div style="height: 300px">
        <ly-video ref="lyVideo"></ly-video>
      </div>
    </Modal>
    <zhiling ref="zhiling"></zhiling>
  </div>
</template>
<script>
var map,
  satelliteLayer = new AMap.TileLayer.Satellite();
var trafficLayer = new AMap.TileLayer.Traffic({
  zIndex: 10,
});
var markers = [];
var myisToCenter = true;
var activeCarDeviceId;
import carTool from "../common/carTool.vue";
import iconWindow from "./com/iconWindow.vue";
import stree from "./com/stree";
import lyVideo from "./com/video.vue";
import lySelect from "../locus/select.vue";
import locusmap from "../locus/map.vue";
import showSet from "./com/showSet.vue";
import zhiling from "./com/zhiling.vue"
import axios from "axios"; //对讲用
export default {
  components: {
    carTool,
    iconWindow,
    stree,
    lyVideo,
    lySelect,
    locusmap,
    showSet,
    zhiling
  },
  data() {
    return {
      isList: true,
      showMsg: true,
      activeCar: {},
      address: "12",
      openStree: false,
      openVideo: false,
      openSelect: false,
      openLocus: false,
    };
  },
  methods: {
    gMap() {
      //getZoom();
      //getCenter();
      map = new AMap.Map("lymap", {
        resizeEnable: true,
        center: [116.397451, 39.909187],
        zoom: 13,
        defaultCursor: "",
      });
      // 同时引入工具条插件，比例尺插件和鹰眼插件
      AMap.plugin(
        [
          "AMap.ToolBar",
          "AMap.Scale",
          "AMap.OverView",
          "AMap.MapType",
          "AMap.Geolocation",
        ],
        function () {
          // 在图面添加工具条控件，工具条控件集成了缩放、平移、定位等功能按钮在内的组合控件
          map.addControl(
            new AMap.ToolBar({
              position: "RT",
              ruler: false,
              //offset:AMap.Pixel(10,30)
            })
          );

          // 在图面添加比例尺控件，展示地图在当前层级和纬度下的比例尺
          map.addControl(
            new AMap.Scale({
              position: "RB",
            })
          );
        }
      );
      //mouseTool = new AMap.MouseTool(map);
      //ruleTool = new AMap.MouseTool(map);
      map.on("complete", function (ev) {
        // 触发事件的对象
        // alert(1)
      });
      //this.getPointList();
    },
    showGpsPoints(data_info, first) {
      var that = this;
      map.remove(markers);
      markers = [];
      for (var i = 0, marker; i < data_info.length; i++) {
        var icon = new AMap.Icon({
          size: new AMap.Size(26, 26), // 图标尺寸
          image:
            "static/" +
            data_info[i].carTypeIcon +
            "/" +
            data_info[i].realTimeStatus +
            "/" +
            data_info[i].direction +
            ".gif", // Icon的图像
          imageOffset: new AMap.Pixel(0, 0), // 图像相对展示区域的偏移量，适于雪碧图等
          imageSize: new AMap.Size(26, 26), // 根据所设置的大小拉伸或压缩图片
        });

        // 创建覆盖物群组，并将 marker 传给 OverlayGroup
        marker = new AMap.Marker({
          map: map,
          position: [data_info[i].gcj02x, data_info[i].gcj02y],
          icon: icon,
          //angle: 45 * (data_info[i].direction - 1),
          //angle: data_info[i].directionDegree,
          //angle:45,
          offset: new AMap.Pixel(-13, -13),
          extData: data_info[i],
          zIndex: 1000,
          // offset: new AMap.Pixel(0, 0)
        });
        //marker.content = components[i].$el;
        //marker.content = '1111111';
        marker.setLabel({
          content:
            // "<div style='transform:rotate(-"+data_info[i].directionDegree+"deg);transform-origin: 0 0;background:#333'>" +
            "<div id='active" +
            data_info[i].deviceId +
            "'>" +
            (data_info[i].alarmStatus == 0
              ? data_info[i].carNo
              : "<span class='alarmNow'>报警</span>" + data_info[i].carNo) +
            "</div>",
          offset: new AMap.Pixel(30, 5),
        });
        marker.on("click", markerClick);

        markers.push(marker);
        if (activeCarDeviceId == data_info[i].deviceId) {
          that.activeCar = data_info[i];
          that.jiexi();
        } else if (first) {
          that.activeCar = data_info[0];
          activeCarDeviceId = data_info[0].deviceId;
          map.panTo([that.activeCar.gcj02x, that.activeCar.gcj02y]);
        }
      }

      function markerClick(e) {
        //console.log(e.target.getzIndex())
        var aaaa = e.target.getExtData();
        that.activeCar = aaaa;
        that.showMsg = true;
        activeCarDeviceId = aaaa.deviceId;
      }
    },
    reAllCar(v, first) {
      this.showGpsPoints(v, first);
    },
    clickTab(tag) {
      if (tag == "list") {
        this.isList = true;
      } else {
        this.isList = false;
      }
    },
    reCar(v) {
      this.isList = false;
      this.activeCar = v;
      activeCarDeviceId = v.deviceId;
      map.panTo([v.gcj02x, v.gcj02y]);
      map.setZoom(18);
      this.jiexi();
    },
    jiexi() {
      var pointList = [
        {
          x: this.activeCar.gcj02x,
          y: this.activeCar.gcj02y,
        },
      ];
      this.utils.jiexi(pointList).then((data) => {
        this.address = data[0].address;
      });
    },
    carBack() {
      map.panTo([this.activeCar.gcj02x, this.activeCar.gcj02y]);
    },
    jiejing() {
      this.openStree = true;
      setTimeout(() => {
        this.$refs.bmapStree.stree(this.activeCar.bd09x, this.activeCar.bd09y);
      }, 200);
    },
    toSpeakPage() {
      console.log(this.activeCar);
      if (this.activeCar.deviceTypeName.indexOf("视频") == -1) {
        this.$Message.warning({
          content: "非视频设备【" + this.activeCar.deviceTypeName + "】",
          duration: 2,
        });
      } else {
        var href =
          axios.yuming +
          "/intercom/speak/?deviceNo=" +
          this.activeCar.deviceNo +
          "&carNo=" +
          this.activeCar.carNo;
        window.open(href);
      }
    },
    zhiling(){
      this.$refs.zhiling.open(this.activeCar);
    },
    reVideo() {
      var aa = this.activeCar.deviceTypeName;
      if (aa.indexOf("视频") == -1) {
        this.$Message.error("非视频设备");
        return;
      }
      this.openVideo = true;
      this.$refs.lyVideo.beforCcreatePlayer(this.activeCar.deviceNo);
    },
    closeVideo() {
      this.$refs.lyVideo.close();
    },
    huifang() {
      this.openSelect = true;
      this.$store.state.carMsg.carNo = this.activeCar.carNo;
      this.$store.state.carMsg.deviceId = this.activeCar.deviceId;
      this.$store.state.carMsg.play = 1;
    },
    getHistory(data) {
      this.openLocus = true;
      this.openSelect = false;
      setTimeout(() => {
        this.$refs.locus.getHistory(data);
      }, 500);
    },
    mySet() {
      this.openSet = true;
    },
    rePointData(v) {
      this.utils.showPoints(map, v);
    },
    reLineData(v) {
      this.utils.showLines(map, v);
    },
    reFenceData(v) {
      this.utils.showFences(map, v);
    },
    reLuKuang(t) {
      trafficLayer.setMap(map); //路况用的
      if (t) {
        trafficLayer.show();
      } else {
        trafficLayer.hide();
      }
    },
    reYun(t) {
      if (t) {
        map.add(satelliteLayer);
      } else {
        map.remove(satelliteLayer);
      }
    },
    openGroup() {
      this.$refs.carTool.openGroup();
    },
  },
  mounted() {
    this.gMap();
  },
};
</script>
<style lang="">
#carListwrap {
  width: 100%;
  height: calc(100% - 0px);
  background: #fff;
  padding: 0 15px;
}
#lymap {
  width: 100%;
  height: calc(100% - 0px);
  background: #ccc;
  position: relative;
}
#lymap #window {
  position: absolute;
  bottom: 0;
  width: 100%;
  z-index: 200;
}
#lymap #window #wintop {
  width: 80px;
  height: 14px;
  background: #3d7ef8;
  margin: 0 auto;
  border-radius: 10px 10px 0 0;
  color: #fff;
  text-align: center;
  font-size: 18px;
  line-height: 10px;
}
#lymap #window #windowBody {
  background: #fff;
  padding: 0 15px;
}
#lymap .activecar {
  background: chocolate;
  color: #fff;
}
.vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;
}
.ivu-modal {
  top: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/locate/index.vue